import { inject, Injectable, signal } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { ApiService, IAllData, IPaging, IProductSearchOptions } from '@web-nx-ng-tsc/web-shared-data-access';
import { environment } from '../../../environments/environment';
import { ProductService } from '../products/product.service';
import { ICategory, ILocalStorageModel, LS, StorageService } from '@web-nx-ng-tsc/data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

export const VISIBILITY = environment.visibility;

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  private readonly apiService = inject(ApiService);
  private readonly productService = inject(ProductService);
  private readonly storageService = inject(StorageService);
  private readonly loggingService = inject(LoggingService);

  private bannerSignal = signal<IAllData | undefined>(undefined);
  private popupSignal = signal<IAllData | undefined>(undefined);
  private promotionListSignal = signal<IAllData | undefined>(undefined);
  private newsListSignal = signal<IAllData | undefined>(undefined);
  private videoListSignal = signal<IAllData | undefined>(undefined);
  private articleListSignal = signal<IAllData | undefined>(undefined);
  private galleryListSignal = signal<IAllData | undefined>(undefined);
  // SECTION: METHOD DO SOMETHING SIGNAL
  // NOTE: GET SIGNAL //
  getBannerSignal() {
    return this.bannerSignal;
  }
  getPopupSignal() {
    return this.popupSignal;
  }
  getPromotionListSignal() {
    return this.promotionListSignal;
  }
  getNewsListSignal() {
    return this.newsListSignal;
  }
  getVideoListSignal() {
    return this.videoListSignal;
  }
  getArticleSignal() {
    return this.articleListSignal;
  }
  getGalleryListSignal() {
    return this.galleryListSignal;
  }
  // ---------------- //
  // !SECTION //

  // SECTION: METHOD GET DATA //
  getBanners() {
    return this.apiService.getAllBanner(VISIBILITY).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getBanners :: =>', res)),
      tap((res: IAllData) => this.bannerSignal.set(res))
    );
  }

  getPopups() {
    return this.apiService.getAllPopup(VISIBILITY).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getPopups :: =>', res)),
      tap((res: IAllData) => this.popupSignal.set(res))
    );
  }

  getPromotionList() {
    this.loggingService.log('FUNC | getPromotionList');
    const paging: IPaging = {
      cur: 1,
      per: 3,
    };
    return this.apiService.getAllPromotion(VISIBILITY, paging).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getPromotionList :: =>', res)),
      tap((res: IAllData) => this.promotionListSignal.set(res))
    );
  }

  getPromotionById(id: number) {
    return this.apiService
      .getPromotionById(id)
      .pipe(tap((res: any) => this.loggingService.log('[GET] getPromotionById :: =>', res)));
  }
  getAllGallery() {
    this.loggingService.log('FUNC | getAllGallery');
    const paging: IPaging = {
      cur: 1,
      per: 3,
    };
    const sort_hot_badge = 1;
    const option = { paging };
    return this.apiService.getAllGallery(VISIBILITY, option, sort_hot_badge).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getAllGallery :: =>', res)),
      tap((res: IAllData) => this.galleryListSignal.set(res))
    );
  }

  getNewsList() {
    const paging: IPaging = {
      cur: 1,
      per: 3,
    };
    return this.apiService.getAllNews(VISIBILITY, paging).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getPromotionById :: =>', res)),
      tap((res: IAllData) => this.newsListSignal.set(res))
    );
  }

  getAllArticle() {
    const paging: IPaging = {
      cur: 1,
      per: 3,
    };
    return this.apiService.getAllArticle(VISIBILITY, paging).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getPromotionById :: =>', res)),
      tap((res: IAllData) => this.articleListSignal.set(res))
    );
  }

  getNewsById(id: number) {
    return this.apiService
      .getNewsById(id)
      .pipe(tap((res: any) => this.loggingService.log('[GET] getPromotionById :: =>', res)));
  }

  getVideoList() {
    const paging: IPaging = {
      cur: 1,
      per: 2,
    };
    return this.apiService.getAllVideo(VISIBILITY, paging).pipe(
      tap((res: IAllData) => this.loggingService.log('[GET] getVideoList :: =>', res)),
      tap((res: IAllData) => this.videoListSignal.set(res))
    );
  }

  getCategory() {
    return this.apiService.getMenuProduct(VISIBILITY).pipe(
      tap((data: any) => {
        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getAllProductByCategory[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }

  // NOTE: CROSS SERVICE
  getAllProductByCategory(category: string, options: IProductSearchOptions, paging?: IPaging): Observable<any> {
    this.productService.clearAllProductSignal();
    return this.productService.getAllProductByCategory(false, category, options, paging);
  }

  getCategoryId(): string {
    const categoryList = this.storageService.get(LS.categoryList) as any;
    this.loggingService.warn('categoryList', categoryList);
    if (categoryList) {
      const categoryState = categoryList.find((item: any) => item.key_name === 'tire');
      return categoryState?.id.toString();
    } else {
      return '';
    }
  }

  getCategoryTire(): ICategory {
    const categoryList = this.storageService.get(LS.categoryList) as any;
    const categoryState = categoryList.find((item: any) => item.key_name === 'tire') as ICategory;
    return categoryState;
  }
  setStorage<K extends keyof ILocalStorageModel>(key: K, value: ILocalStorageModel[K]): void {
    this.storageService.set(key, value);
  }
  // !SECTION //
}
